module.exports = __webpack_public_path__ + "img/sports-news.76bf5b1c.jpg";